module.exports = __webpack_public_path__ + "static/media/ban-khar-work-intro-bg.955b740e.svg";